export default __webpack_public_path__ + "static/media/LOGO.9181a315.png";